<template functional>
  <fragment>
    <div
      class="font_Montserrat font_size_875rem v3_color_teal letter_spacing_1 text-uppercase"
    >
      {{ props.title }}
    </div>
    <div
      class="font_Montserrat v3_color_black_knight"
      :class="props.valueFontSizeClass"
      v-html="props.value"
    />
  </fragment>
</template>

<script>
export default {
  name: 'StatusColumn',
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      required: true,
    },
    valueFontSizeClass: {
      type: String,
      default: 'font_size_1000rem text_uppercase'
    },
  },
};
</script>

<style scoped></style>
